import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';

// Define the GraphQL query for fetching dive equipment details
const getDiveEquipmentQuery = graphql(/* GraphQL */ `
  query diveEquipmentByUserId($userId: String!) {
    diveEquipmentByUserId(userId: $userId) {
      equipmentId
      userId
      bcd
      wetsuit
      fins
    }
  }
`);

// Custom hook for fetching dive equipment details
const useGetDiveEquipment = (userId: string, enabled = true) => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    diveEquipmentByUserId: {
      equipmentId: number;
      userId: string;
      bcd: string;
      wetsuit: string;
      fins: string;
    } | null;
  }>({
    queryKey: ['diveEquipment', userId],
    queryFn: async () =>
      graphqlRequest(
        getDiveEquipmentQuery,
        { userId },
        enabled && isAuthenticated ? getAccessTokenSilently : undefined,
      ),
    enabled: enabled && isAuthenticated,
    retry: shouldRetryQuery,
  });

  const diveEquipment = data?.diveEquipmentByUserId;

  return {
    diveEquipment,
    isLoading,
    isError: !!error,
    error,
    refetch,
    isFetching,
  };
};

export default useGetDiveEquipment;
